<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-date-picker
                    :end-validations="validations.periodo"
                    :range-inline="false"
                    :start-validations="validations.periodo"
                    end-label="Até"
                    range
                    start-label="Período de"
                    v-model="model.periodo"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                unidade: {required: true},
                infraestrutura: {required:true},
            }
        },
    },
    created() {
        this.repositories = {
            jornadaBloqueio: this.getConectaSusRepository('exameLaboratorial.jornadaBloqueio'),
        }
    },
    data: () => ({
        form: null,
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.jornadaBloqueio.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.model.periodo.start = this.others.moment(this.model.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        this.model.periodo.end = this.others.moment(this.model.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.jornadaBloqueio.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        infraestruturaId: this.model.infraestruturaId,
                        inicio: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        fim: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                    }

                    if (this.id) {
                        this.repositories.jornadaBloqueio.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.jornadaBloqueio.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                listar: 'infraestruturas',
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornadaBloqueio.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = response.data

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number },
    },
}
</script>